/** User-facing strings for Print Physical DR toolbar and errors. */

export const PHYSICAL_DR_CONTENT = {
  snackbar: {
    error: "Could not print paper delivery receipts. Please try again",
  },
  errors: {
    generateFailed: "Failed to generate paper DR, please retry.",
  },
  logging: {
    printPipelineFailed: "Physical DR print pipeline failed",
  },
  tooltip: {
    generating: "Generating paper delivery receipt...",
    selectRow: "Select a row to print paper delivery receipts.",
    selectSingleRow: "Select single row to print paper delivery receipts",
    rowWithoutRoute: "Paper delivery receipts not available",
    noPhysicalDrNeed: "No paper delivery receipt required for this route.",
    print: "Print paper delivery receipts",
  },
  dispatchPanel: {
    sectionHeader: "Paper Delivery Receipt",
    buttonLabel: "Print",
    checkboxLabel: "Print paper delivery receipts",
    tooltipSelectTrailer: "Select a trailer to print delivery receipt",
    tooltipNoPhysicalDrNeed: "No paper delivery receipt required for this route",
  },
  loader: {
    generating: "Generating paper delivery receipt",
  },
} as const;

export function getPhysicalDrTooltipTitle(options: {
  isGenerating: boolean;
  terminalCode: string | undefined;
  routeId: string | undefined;
  hasPhysicalDrNeed: boolean;
  selectedRowCount: number;
}): string {
  const { tooltip } = PHYSICAL_DR_CONTENT;
  const {
    isGenerating,
    terminalCode,
    routeId,
    hasPhysicalDrNeed,
    selectedRowCount,
  } = options;
  if (isGenerating) {
    return tooltip.generating;
  }
  if (!terminalCode) {
    return tooltip.selectRow;
  }
  if (selectedRowCount === 0) {
    return tooltip.selectRow;
  }
  if (selectedRowCount > 1) {
    return tooltip.selectSingleRow;
  }
  if (!routeId) {
    return tooltip.rowWithoutRoute;
  }
  if (!hasPhysicalDrNeed) {
    return tooltip.noPhysicalDrNeed;
  }
  return tooltip.print;
}
